<template>
  <div
    v-show="dialog"
    width="auto"
    class="preview-modal-overlay"
    @click="closeDialog()">
    <div class="preview-modal">
      <v-card class="preview-image-card">
        <div class="preview-image-box">
          <img
            :src="$convertImgix(`${imgSrc}?w=1024`)"
            class="preview-image"
            alt="preview-image">
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true
    },
    imgSrc: {
      type: String,
      default: null
    }
  },
  computed: {
    dialog: {
      get () {
        return this.value
      },
      set (newVal) {
        this.$emit('input', newVal)
      }
    }
  },
  methods: {
    closeDialog () {
      this.dialog = false
    }
  }
}
</script>

<style lang="scss" scoped>
.preview-image-card {
  position: relative;
  img.preview-image {
    max-height: 80vh;
    max-width: 80vw;
  }
  .preview-image-close {
    position: absolute;
    background-color: white;
    top: 10px;
    right: 10px;
  }
}
.preview-modal-overlay {
  position: fixed;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
}

.preview-modal {
  z-index: 10000;
  position: fixed;
}
</style>
